import { lazy, Suspense } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Header from './Header';
import Footer from './Footer';
import SiteBackground from './SiteBackground';
import SplashScreen from './SplashScreen';
import { useAos } from '../hooks/useAos';
import { useNavbarScroll } from '../hooks/useSiteEffects';

const CookieBanner = lazy(() => import('./CookieBanner'));

export default function Layout({ children, title, description, footerAboutText, showSplash = false }) {
  const location = useLocation();
  const isHome = location.pathname === '/' || location.pathname === '/index.html';
  const shouldShowSplash = showSplash || isHome;
  const effectsDelay = shouldShowSplash ? 900 : 0;

  useAos(effectsDelay);
  useNavbarScroll(effectsDelay);

  return (
    <>
      <Helmet>
        <title>{title}</title>
        {description && <meta name="description" content={description} />}
        <meta name="theme-color" content="#06060b" />
      </Helmet>
      <SiteBackground />
      <div className="in-page">
        {shouldShowSplash && <SplashScreen />}
        <Suspense fallback={null}>
          <CookieBanner />
        </Suspense>
        <Header />
        <main>{children}</main>
        <Footer aboutText={footerAboutText} />
      </div>
    </>
  );
}
